import { useEffect, useState } from "react";
import { Bell } from "lucide-react";
import { formatDate, useApi } from "@/lib/api";

// Latest team notifications of the space (new requests, bookings, paid orders...): titles only, no personal data on the overview.
export function RecentNotifications({ tid }) {
  const api = useApi();
  const [list, setList] = useState(null);
  useEffect(() => { api.get(`/t/${tid}/notifications`).then(({ data }) => setList(data.slice(0, 6))).catch(() => setList(false)); }, [api, tid]);
  if (!list) return null;
  return (
    <section className="rounded-xl border border-slate-200 bg-white p-4" data-testid="ov-notifications">
      <p className="flex items-center gap-1.5 text-sm font-medium text-slate-800"><Bell size={14} />Ultime notifiche</p>
      {!list.length ? <p className="mt-1 text-xs text-slate-500">Nessuna notifica.</p> :
        <ul className="mt-2 divide-y divide-slate-100 text-sm">{list.map((n) => (
          <li key={n.id} className="flex flex-wrap items-baseline justify-between gap-x-3 py-1.5" data-testid={`ov-notification-${n.id}`}>
            <span className="min-w-0 break-words text-slate-700">{n.title}</span><span className="shrink-0 text-xs text-slate-500">{formatDate(n.at, true)}</span></li>))}</ul>}
    </section>);
}
